module.exports = __webpack_public_path__ + "static/media/4.056d6842.jpg";